import React from 'react';
import { Pivot, PivotItem } from '@fluentui/react';
import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';
import { EntityType, IUserConfigPackage } from '../API';
import EntityDashboardState from '../state/EntityDashboardState';
import EntityDashboard from '../components/dashboards/EntityDashboard';
import StandaloneSearchTab, { StandaloneSearchTabState } from '../components/pages/StandaloneSearchTab';
import { AgentChatState } from '../components/controls/AgentChat';
import UserWelcome, { UserWelcomeState } from '../components/controls/UserWelcome';
import { EntityDetailsState } from '../components/controls/EntityDetails';
import RecentDocuments, { RecentDocumentsState } from '../components/controls/RecentDocuments';
import WidgetOutline, { WidgetOutlineState } from '../components/controls/WidgetOutline';

export interface IFullAppHomeProps {
	state: FullAppHomeState;
}

class FullAppHome extends React.Component<IFullAppHomeProps> {
	
	render() {

		window.document.body.style.backgroundColor = '#f3f2f1';

		return (
			<>
				<Pivot styles={{ root: { backgroundColor: 'white' } }}>
					<PivotItem headerText='Home'>
						<div style={{marginLeft:20, marginRight:20}}>
							
							<div style={{marginTop:20, marginBottom: 20}}>
								<UserWelcome state={this.props.state.userWelcome} />
							</div>

							{/*
							<AgentChat state={this.props.state.agentChat} />
							 */}
							<WidgetOutline state={new WidgetOutlineState('Recent documents', 'Document')}>	
								<RecentDocuments state={this.props.state.recentDocuments} />		
							</WidgetOutline>
						</div>
					</PivotItem>
					<PivotItem headerText='Files'>
						<div style={{marginLeft:20, marginRight:20}}>
							<StandaloneSearchTab state={this.props.state.fileSearch} />
						</div>
					</PivotItem>
					{this.props.state.dashboards.map(d => (
						<PivotItem headerText={d.getConfig().pluralName} key={d.getConfig().id}>
							<div style={{marginLeft:20, marginRight:20}}>
								<EntityDashboard state={d} />
							</div>
						</PivotItem>
					))}
				</Pivot>
			</>
		);
	}

}

export default observer(FullAppHome);

export class FullAppHomeState {
	userConfig: IUserConfigPackage;

	userWelcome: UserWelcomeState;
	agentChat: AgentChatState;
	fileSearch: StandaloneSearchTabState;
	recentDocuments: RecentDocumentsState;
	dashboards: EntityDashboardState[];

	constructor(userConfig:IUserConfigPackage, entityDialog: EntityDetailsState) {
		this.userConfig = userConfig;

		this.userWelcome = new UserWelcomeState(userConfig);
		this.agentChat = new AgentChatState(userConfig, entityDialog);
		this.fileSearch = new StandaloneSearchTabState(userConfig);
		this.recentDocuments = new RecentDocumentsState(userConfig);

		this.dashboards = this.userConfig.entityTypes.entityTypes.filter(d => d.type === EntityType.None).map(element => {
			return new EntityDashboardState(element.id, userConfig, entityDialog);
		});

		makeAutoObservable(this);
	}

}
